const styles = (theme) => ({
  terminalGrid: {
    margin: "20 0 60 0",
    height: 300,
  },
  statusBar: {
    margin: "unset",
    padding: 6,
    border: `1px solid ${theme.AppBGColor}`,
  },
  paperAnchor: {
    position: "absolute",
    width: 380,
    zIndex: 1,
    backgroundColor: theme.ModalBGColor,
  },
});

export default styles;
